import { render, staticRenderFns } from "./VersionInformation.vue?vue&type=template&id=1b080374&scoped=true&"
import script from "./VersionInformation.vue?vue&type=script&lang=js&"
export * from "./VersionInformation.vue?vue&type=script&lang=js&"
import style0 from "./VersionInformation.vue?vue&type=style&index=0&id=1b080374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b080374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b080374')) {
      api.createRecord('1b080374', component.options)
    } else {
      api.reload('1b080374', component.options)
    }
    module.hot.accept("./VersionInformation.vue?vue&type=template&id=1b080374&scoped=true&", function () {
      api.rerender('1b080374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/VersionInformation.vue"
export default component.exports